(function () {
    "use strict";

    /**
     * Constructor for class {@link CompanySettingsOverviewController}
     * @param $scope
     * @param CompaniesManager
     * @param AnalyticsService
     * @see CompaniesManager
     */
    // @ngInject
    function CompanySettingsOverviewControllerCtor($scope, $injector, $translate,
                                                   CompaniesManager, AnalyticsService, ModalService, PopupMessageService, CompanyService, AppConfigService, TimezoneService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsOverviewController';

        this.CompaniesManager = CompaniesManager;
        this.AnalyticsService = AnalyticsService;
        this.ModalService = ModalService;
        this.companyService = CompanyService;
        this.TimezoneService = TimezoneService;
        this.PopupMessageService = PopupMessageService;
        this.$translate = $translate;
        this.projectTypes = angular.copy(this.company.sortedProjectTypes());
        this.newProjectType = {label: "", editInProgress: false};
        this.projectTypOldValue = "";

        this.companyTypes = this.companyService.getCompanyTypesSorted();
        this.timezones = TimezoneService.getTimezones();

        this.initializeCompanyType();
        this.initializeTimezone();
        this.initProjectTypesVm();

        // there is a default company type until the model will be loaded
        if (!this.company.wasFullyFetched()) {
            this.registerOnce(this.company, 'success', function gotCompany() {
                this.initializeCompanyType();
                this.initializeTimezone();
                this.initProjectTypesVm();
                this.stateTitle = this.company.country === 'CA' ? 'COMPANY_SETTING.LABELS._PROVINCE_' : 'COMPANY_SETTING.LABELS._STATE_';
                this.zipTitle = this.company.country === 'CA' ? 'COMPANY_SETTING.LABELS._POSTAL_CODE_' : 'COMPANY_SETTING.LABELS._ZIP_CODE_';
            }.bind(this));
        }
    }


    var CompanySettingsOverviewController = Class(Controllers.BaseController, {

        constructor: CompanySettingsOverviewControllerCtor,

        /**
         * Saves the changes done in the company model to the server
         */
        saveChanges: function saveChanges(force) {
            var self = this;

            var validations = this.$scope.overviewForm;
            if ((force || validations.$dirty) && validations.$valid) {
                var promise = this.CompaniesManager.saveCompanyFields(this.company, null, this.useMalkutPath);
                promise.then(function success(){
                    // Clear validations
                    validations.$setPristine();

                    var analyticsArgs = {
                        company: self.company._id
                    };

                    self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.company_updated, analyticsArgs);
                });
            }
        },

        changeLogoPhoto: function changeLogoPhoto() {
            this.ModalService.openUploadLogoPhotoModal(this.company);
        },

        changeIconPhoto: function changeIconPhoto() {
            this.ModalService.openUploadIconPhotoModal(this.company);
        },

        changeDefaultHeaderPhoto: function changeDefaultHeaderPhoto() {
            this.ModalService.openUploadLogoPhotoModal(this.company);
        },


        setActiveCompanyType: function setActiveCompanyType(type) {
            this.company.company_type = type.key;
            this.selectedCompanyType = type;
            this.saveChanges(true);
        },

        initializeCompanyType: function initializeCompanyType(){
            this.selectedCompanyType = this.companyService.getSelectedCompanyTypeFromEnum(this.company);
        },
        
        companyTypeIsOther: function companyTypeIsOther() {
          return this.company.company_type == 'other'
        },
        
        setDefaultTimezone: function setDefaultTimezone(timezone) {
            var self = this;
            var analyticsArgs = {
                company: self.company._id,
                timezone: timezone
            };
            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.company_updated_timezone, analyticsArgs);
            this.selectedTimezone = timezone;
            this.company.default_timezone = this.TimezoneService.translateToServer(timezone);
            this.saveChanges(true);
        },

        initializeTimezone: function initializeTomezone() {
            this.selectedTimezone = this.TimezoneService.translateFromServer(this.company.default_timezone);
            if (!this.selectedTimezone) {
                this.selectedTimezone = this.TimezoneService.DEFAULT_TIMEZONE;
            }
        },

        inputFieldColor: function inputFieldColor(color) {
            this.company.brand_color = color;
            //todo choose a lighter color for hovering

            //todo determine if we need to set the text_color here based on contrast problems

            this.saveChanges(true);
            this.AnalyticsService.track(this, 'color choose', {color_for: 'field color'});
        },

        pickerOpenedFieldColor: function pickerOpenedFieldColor() {
            this.AnalyticsService.track(this, 'open color picker', {color_for: 'field color'});
        },

        onProjectTypeUpdate: function onProjectTypeUpdate(projectType) {

            if (projectType.editInProgress) {
                return;
            }

            projectType.editInProgress = true;

            this.CompaniesManager.updateProjectType(this.company, projectType)
                .then(this.initProjectTypesVm.bind(this))
                .catch(function error(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                }.bind(this))
                .finally(function final() {
                   projectType.editInProgress = false;
                });
        },

        onProjectTypeCreate: function onProjectTypeCreate(newProjectType,callback) {

            if (newProjectType.editInProgress || newProjectType.label == "") {
                return;
            }

            newProjectType.editInProgress = true;

            this.CompaniesManager.createProjectType(this.company, newProjectType.label)
                .then(this.initProjectTypesVm.bind(this))
                .catch(function error(resp) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                }.bind(this))
                .finally(function final() {
                     newProjectType.editInProgress = false;
                    callback();
                }.bind(this));
        },

        onProjectTypeDelete: function onProjectTypeDelete(projectType) {
            if (projectType.editInProgress) {
                return;
            }

            var confirmMessage = this.$translate.instant('COMPANY_SETTING.PROJECT_TYPES._DELETE_CONFIRM_', {projectType: projectType.label});
            this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, confirmMessage).then(function confirm() {
                projectType.editInProgress = true;

                this.CompaniesManager.deleteProjectType(this.company, projectType._id)
                    .then(this.initProjectTypesVm.bind(this))
                    .catch(function error(resp) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, resp.data.error_message);
                    }.bind(this))
                    .finally(function final() {
                        projectType.editInProgress = false;
                    });
            }.bind(this));
        },


        initProjectTypesVm: function initProjectTypesVm() {
            this.projectTypes = angular.copy(this.company.sortedProjectTypes());
        }
    });

    Directives.CompanySettingsOverviewDirective =  function CompanySettingsOverviewDirective(){
        return {
            scope:{
                user: '=user',
                company: '=company',
                controller: '=',
                useMalkutPath: '=usemalkutpath'
            },
            templateUrl : 'angular/app/modules/core/features/company_settings/overview/company_settings_overview_template.html',
            controller : CompanySettingsOverviewController,
            controllerAs : 'companySettingsOverviewVm',
            bindToController : true,
            link: function(scope) {
                // Expose the overviewForm to external controllers.
                scope.companySettingsOverviewVm.controller = scope.companySettingsOverviewVm || {};
            }
        };
    };

}());
